import { countryCodes } from './enums/countryCodes';
import { languageCodes } from './enums/languageCodes';
import { currencyCodes } from './enums/currencyCodes';
import type { CountryConfigurationOptions } from '~~/types/localization/countryConfigurationOptions';

export const countryConfigurations: CountryConfigurationOptions[] = [
  {
    countryCode: countryCodes.AT,
    label: 'Austria',
    languages: [languageCodes.de],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '9d72683f81b6' }],
    bloomreachByLanguage: [{ key: '612b67a0-2000-11ea-97de-02847d4e679f' }],
    languageAndCountryFallbacks: [
      { language: languageCodes.de, countryCode: countryCodes.DE },
    ],
  },
  {
    countryCode: countryCodes.BE,
    label: 'Belgium',
    languages: [languageCodes.fr, languageCodes.nl],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [
      { language: languageCodes.fr, parcelPerformId: 'f636aad955a6' },
      { language: languageCodes.nl, parcelPerformId: '33f8509e80e3' },
    ],
    bloomreachByLanguage: [
      { language: languageCodes.fr, key: 'e7223ae4-2002-11ea-a509-02847d4e679f' },
      { language: languageCodes.nl, key: '05b09f3c-2003-11ea-aeab-2266c08974f0' },
    ],
    languageAndCountryFallbacks: [
      { language: languageCodes.fr, countryCode: countryCodes.FR },
      { language: languageCodes.nl, countryCode: countryCodes.NL },
    ],
  },
  {
    countryCode: countryCodes.BG,
    label: 'Bulgaria',
    languages: [languageCodes.bg],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '' }],
    bloomreachByLanguage: [{ key: 'e4299884-dee3-11ed-8456-1ef90d2a052a' }],
  },
  {
    countryCode: countryCodes.CH,
    label: 'Switzerland',
    languages: [languageCodes.de, languageCodes.fr, languageCodes.it],
    currencyCode: currencyCodes.CHF,
    enableNativeRouting: false,
    parcelPerformByLanguage: [
      { language: languageCodes.de, parcelPerformId: 'be0e7b604069' },
      { language: languageCodes.it, parcelPerformId: 'f24d4d81bbbf' },
      { language: languageCodes.fr, parcelPerformId: '6dc7badfbcb6' },
    ],
    bloomreachByLanguage: [
      { language: languageCodes.de, key: '6a369368-2002-11ea-80f6-7641af141315' },
      { language: languageCodes.fr, key: '8fa9ab12-2002-11ea-a298-2266c08974f0' },
      { language: languageCodes.it, key: 'b7914f2c-2002-11ea-8f68-7abb5e11b5e7' },
    ],
    languageAndCountryFallbacks: [
      { language: languageCodes.de, countryCode: countryCodes.DE },
      { language: languageCodes.fr, countryCode: countryCodes.FR },
      { language: languageCodes.it, countryCode: countryCodes.IT },
    ],
    testPlaywrightVatProfile: {
      featureProfile: 'vat-disabled',
    },
  },
  {
    countryCode: countryCodes.GB,
    label: 'United Kingdom',
    languages: [languageCodes.en],
    currencyCode: currencyCodes.GBP,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: 'a988cef4236e' }],
    bloomreachByLanguage: [{ key: 'fea5ba72-1fff-11ea-a30f-5eb5c90936dd' }],
    customDomainEnding: 'co.uk',
    customStoreEnding: 'co_uk',
  },
  {
    countryCode: countryCodes.CZ,
    label: 'Czech Republic',
    languages: [languageCodes.cs],
    currencyCode: currencyCodes.CZK,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '743dcc35ac1b' }],
    bloomreachByLanguage: [{ key: '96cb2d4a-2001-11ea-8519-7abb5e11b5e7' }],
  },
  {
    countryCode: countryCodes.DE,
    label: 'Germany',
    languages: [languageCodes.de],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '8baa8cc15002' }],
    bloomreachByLanguage: [{ key: 'bd34e8ba-1fff-11ea-bb3a-7abb5e11b5e7' }],
    testPlaywrightVatProfile: {
      featureProfile: 'vat-enabled-tax-enabled',
      runInvalidVatWithoutBlurContinueFlow: true,
      runValidVatWithoutBlurContinueFlow: true,
      runEmptyVatWithoutBlurContinueFlow: true,
      expectInvalidVatWarningWhenTaxRateChangeDisabled: true,
    },
  },
  {
    countryCode: countryCodes.DK,
    label: 'Denmark',
    languages: [languageCodes.da],
    currencyCode: currencyCodes.DKK,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '5e0a79f27f03' }],
    bloomreachByLanguage: [{ key: '251a2a24-2002-11ea-af10-7abb5e11b5e7' }],
  },
  {
    countryCode: countryCodes.ES,
    label: 'Spain',
    languages: [languageCodes.es],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '28b4febf2a12' }],
    bloomreachByLanguage: [{ key: 'fcc47076-2000-11ea-bd3b-6ed5fa2c410f' }],
  },
  {
    countryCode: countryCodes.FI,
    label: 'Finland',
    languages: [languageCodes.fi],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '7eb702ad0ff9' }],
    bloomreachByLanguage: [{ key: '2de76f8c-2001-11ea-83b1-2266c08974f0' }],
  },
  {
    countryCode: countryCodes.FR,
    label: 'France',
    languages: [languageCodes.fr],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: 'f1ee7aaa5380' }],
    bloomreachByLanguage: [{ key: '94310704-2000-11ea-a5e9-c266077c1d92' }],
  },
  {
    countryCode: countryCodes.GR,
    label: 'Greece',
    languages: [languageCodes.el],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '' }],
    bloomreachByLanguage: [{ key: '68e4c83c-dee4-11ed-8103-9a034ce46f20' }],
  },
  {
    countryCode: countryCodes.HR,
    label: 'Croatia',
    languages: [languageCodes.hr],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '' }],
    bloomreachByLanguage: [{ key: '2d7c6cfa-dee4-11ed-ac21-a2bf0cb20f85' }],
  },
  {
    countryCode: countryCodes.HU,
    label: 'Hungary',
    languages: [languageCodes.hu],
    currencyCode: currencyCodes.HUF,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '32d384e27c8b' }],
    bloomreachByLanguage: [{ key: '0a9c0b96-548b-11ea-8f5f-6e4a0cd122c0' }],
  },
  {
    countryCode: countryCodes.IE,
    label: 'Ireland',
    languages: [languageCodes.en],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '4b8f9479d6af' }],
    bloomreachByLanguage: [{ key: 'bd3f348a-2001-11ea-8a48-02847d4e679f' }],
    languageAndCountryFallbacks: [
      { language: languageCodes.en, countryCode: countryCodes.GB },
    ],
  },
  {
    countryCode: countryCodes.IT,
    label: 'Italy',
    languages: [languageCodes.it],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: 'a5459118f459' }],
    bloomreachByLanguage: [{ key: 'b748420c-2000-11ea-8409-9ab905018a3b' }],
  },
  {
    countryCode: countryCodes.LT,
    label: 'Lithuania',
    languages: [languageCodes.lt],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: true,
    parcelPerformByLanguage: [{ parcelPerformId: '' }],
    bloomreachByLanguage: [{ key: 'ac94db7e-7091-11ed-9d53-fe8ef836446c' }],
  },
  {
    countryCode: countryCodes.NL,
    label: 'Netherlands',
    languages: [languageCodes.nl],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '0cbd64eedd3d' }],
    bloomreachByLanguage: [{ key: 'f9bb98a4-2001-11ea-a6c5-6ed5fa2c410f' }],
  },
  {
    countryCode: countryCodes.NO,
    label: 'Norway',
    languages: [languageCodes.nb],
    currencyCode: currencyCodes.NOK,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: 'eb6d54426cce' }],
    bloomreachByLanguage: [{ key: '8f9d70b4-548b-11ea-8d4f-2a548b141b25' }],
  },
  {
    countryCode: countryCodes.PL,
    label: 'Poland',
    languages: [languageCodes.pl],
    currencyCode: currencyCodes.PLN,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '39aadd4a0f9c' }],
    bloomreachByLanguage: [{ key: 'f01789a8-088f-11eb-bb5b-3290950b0a23' }],
    testPlaywrightVatProfile: {
      featureProfile: 'vat-enabled-tax-disabled',
      runValidVatWithoutBlurContinueFlow: true,
      runInvalidVatWithoutBlurContinueFlow: true,
      runEmptyVatWithoutBlurContinueFlow: true,
      expectInvalidVatWarningWhenTaxRateChangeDisabled: true,
    },
  },
  {
    countryCode: countryCodes.PT,
    label: 'Portugal',
    languages: [languageCodes.pt],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '68139e1565ce' }],
    bloomreachByLanguage: [{ key: '4b042172-2002-11ea-af10-7abb5e11b5e7' }],
  },
  {
    countryCode: countryCodes.RO,
    label: 'Romania',
    languages: [languageCodes.ro],
    currencyCode: currencyCodes.RON,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '' }],
    bloomreachByLanguage: [{ key: '880ef3bc-5542-11ed-bfa2-8a678d008999' }],
  },
  {
    countryCode: countryCodes.SE,
    label: 'Sweden',
    languages: [languageCodes.sv],
    currencyCode: currencyCodes.SEK,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '86eeed6db148' }],
    bloomreachByLanguage: [{ key: '64054918-2001-11ea-a8b0-02847d4e679f' }],
  },
  {
    countryCode: countryCodes.SK,
    label: 'Slovakia',
    languages: [languageCodes.sk],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '92123b4e844d' }],
    bloomreachByLanguage: [{ key: '0b2dfe52-79fa-11ec-884c-6a6262712ad7' }],
    testPlaywrightVatProfile: {
      featureProfile: 'vat-enabled-tax-enabled',
      runValidVatWithoutBlurContinueFlow: true,
      runEmptyVatWithoutBlurContinueFlow: true,
      runValidationPersistenceAfterCartMutationFlow: true,
      runSwitchToPrivateAfterValidVatFlow: true,
      runSplitAddressMissingFlow: true,
      expectInvalidVatWarningWhenTaxRateChangeDisabled: false,
      runValidationPersistenceAfterExitFlow: true,
    },
  },
  {
    countryCode: countryCodes.SI,
    label: 'Slovenia',
    languages: [languageCodes.sl],
    currencyCode: currencyCodes.EUR,
    enableNativeRouting: false,
    parcelPerformByLanguage: [{ parcelPerformId: '' }],
    bloomreachByLanguage: [{ key: '2797cf26-5543-11ed-b479-f6a1cbed124c' }],
  },
];
